<template>
  <b-container>
    <b-overlay :show="loading">
      <form-wizard
        @on-complete="confirmation"
        @on-change="verifAndSetAnalyse"
        :start-index="0"
        color="#F7931E"
        title=""
        subtitle=""
        step-
        ref="stepWizard"
        back-button-text="Retour"
        next-button-text="Suivant"
        finish-button-text="Enregistrer"
      >
        <tab-content
          title="Détails de l'échantillon"
          icon="fas fa-vial"
          :before-change="postEnregistrementStorage"
        >
          <b-card>
            <b-form ref="rulesForm">
              <b-form-group>
                <b-row>
                  <b-col class="p-0" md="12" lg="12">
                    <b-input-group>
                      <b-col>
                        <b-form-group v-if="modeEdition !== 'edit'">
                          <b-row>
                            <b-col v-if="isSac" md="6" lg="6">
                              <b-form-group>
                                <h6>
                                  <i class="fa fa-angle-down"></i> Client
                                  <span style="color: red">*</span>
                                </h6>
                                <template>
                                  <multiselect
                                    v-model="selectedClient"
                                    :options="clients"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Rechercher un client"
                                    track-by="login"
                                    :custom-label="customLabel"
                                    :class="validator['CENT_CLT'] === false ? 'input-error' : ''"
                                    @input="onClientSelected"
                                  >
                                    <template #option="{ option }">
                                      {{ option.fullName }} ({{ option.login }})
                                    </template>
                                  </multiselect>
                                </template>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" lg="6" v-if="isSac">
                              <b-form-group>
                                <h6>
                                  <i class="fa fa-angle-down"></i> Famille
                                  <span style="color: red">*</span>
                                </h6>
                                <multiselect
                                  v-model="syncedFamilyData"
                                  :options="familiesForEchantillon"
                                  selectLabel=""
                                  selectedLabel="Sélectionné"
                                  deselectLabel=""
                                  :class="validator['CENT_FAM'] === false ? 'input-error' : ''"
                                  track-by="CFAM_FAM"
                                  label="fullName"
                                  :preserve-search="true"
                                  :disabled="!clientSelected && isSac"
                                >
                                  <template slot="singleLabel" slot-scope="{ option }">
                                    <span>{{ option.CFAM_LIB }}</span>
                                  </template>
                                </multiselect>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form-group>
                        <b-form-group
                          :description="descCom(analysePreSelected, 95)"
                        >
                          <h6>
                            <i class="fa fa-angle-down"></i> Libellé échantillon
                            <span style="color: red">*</span>
                          </h6>
                          <div>
                            <b-form-input
                              v-model="analysePreSelected"
                              list="my-list-id"
                              :state="validator['CENT_LIB']"
                              maxlength="95"
                            ></b-form-input>

                            <datalist id="my-list-id">
                              <option
                                v-for="option in libelleEchantillon"
                                :key="option.CWL_NUM"
                                :value="option.fullName"
                              />
                            </datalist>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-input-group>
                  </b-col>
                  <b-col md="6" lg="6" v-if="!isSac">
                    <b-form-group>
                      <h6>
                        <i class="fa fa-angle-down"></i> Produit
                        <span style="color: red">*</span>
                      </h6>
                      <multiselect
                        v-model="productDataSelected"
                        :options="productsForEchantillon"
                        selectLabel=""
                        selectedLabel="Sélectionné"
                        deselectLabel=""
                        :class="
                          validator['CENT_PRD'] === false ? 'input-error' : ''
                        "
                        track-by="fullName"
                        label="fullName"
                        :preserve-search="true"
                      >
                        <template slot="option" slot-scope="{ option }">
                          <strong
                            ><span> </span> {{ option.CPRD_LIB }}</strong
                          ></template
                        >
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" lg="6" v-if="!isSac">
                      <b-form-group>
                        <h6>
                          <i class="fa fa-angle-down"></i> Famille
                          <span style="color: red">*</span>
                        </h6>
                        <multiselect
                          v-model="syncedFamilyData"
                          :options="familiesForEchantillon"
                          selectLabel=""
                          selectedLabel="Sélectionné"
                          deselectLabel=""
                          :class="validator['CENT_FAM'] === false ? 'input-error' : ''"
                          track-by="CFAM_FAM"
                          label="fullName"
                          :preserve-search="true"
                          :disabled="!clientSelected && isSac"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            <span>{{ option.CFAM_LIB }}</span>
                          </template>
                        </multiselect>
                      </b-form-group>
                  </b-col>

                  <b-col md="12" lg="12">
                    <hr />
                  </b-col>

                  <b-col md="6" lg="3" v-if="!isSac">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_CECH, 10)"
                    >
                      <h6>Code échantillon</h6>
                      <b-form-input
                        maxlength="10"
                        v-model="enregistrement.CENT_CECH"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>
                        <i class="fa fa-angle-down"></i> N° Rapport
                        <span style="color: red">*</span>
                      </h6>
                      <multiselect
                        v-model="numRapportSelected"
                        :options="listNumRapport"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          ><span>{{ option }}</span></template
                        >
                      </multiselect>
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3"  v-if="!isSac">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_TXT1, 80)"
                    >
                      <h6>
                        <i
                          v-if="itemsRefClient.length"
                          class="fa fa-angle-down"
                        ></i>
                        Ref client
                      </h6>
                      <div>
                        <b-form-input
                          v-model="enregistrement.CENT_TXT1"
                          list="listRefClient"
                          :disabled="!canAddClient"
                          maxlength="80"
                        ></b-form-input>

                        <datalist id="listRefClient">
                          <option
                            v-for="option in itemsRefClient"
                            :key="option.ID"
                            :value="option.libelle"
                          />
                        </datalist>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3"  v-if="!isSac">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_TXT2, 80)"
                    >
                      <h6>
                        <i
                          v-if="itemsRefFournisseur.length"
                          class="fa fa-angle-down"
                        ></i>
                        Ref fournisseur
                      </h6>
                      <div>
                        <b-form-input
                          v-model="enregistrement.CENT_TXT2"
                          list="listRefFournisseur"
                          :disabled="!canAddFournisseur"
                          maxlength="80"
                        ></b-form-input>

                        <datalist id="listRefFournisseur">
                          <option
                            v-for="option in itemsRefFournisseur"
                            :key="option.ID"
                            :value="option.libelle"
                          />
                        </datalist>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3"  v-if="!isSac">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_TXT3, 80)"
                    >
                      <h6>N° de lot</h6>
                      <b-form-input
                        maxlength="80"
                        v-model="enregistrement.CENT_TXT3"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3" v-if="!isSac">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_COD_CLT, 10)"
                    >
                      <h6>Votre code produit</h6>
                      <b-form-input
                        maxlength="10"
                        v-model="enregistrement.CENT_COD_CLT"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>
                        Date prélèvement <span style="color: red">*</span>
                      </h6>
                      <b-form-input
                        onfocus="(this.type='date')"
                        onBlur="(this.type='text')"
                        data-vv-as="'Date prélèvement'"
                        type="text"
                        ref="inputDATPRLT"
                        @blur="checkStateModel"
                        v-model="enregistrement.CENT_DATPRLT"
                        :state="validator['CENT_DATPRLT']"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>Date réception <span style="color: red">*</span></h6>
                      <b-form-input
                        onfocus="(this.type='date')"
                        onBlur="(this.type='text')"
                        data-vv-as="'Date prélèvement'"
                        type="text"
                        ref="inputDATSOUHAIT"
                        v-model="enregistrement.CENT_DATSOUHAIT"
                        :state="validator['CENT_DATSOUHAIT']"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>Date fabrication</h6>
                      <span
                        v-if="typeAnalysePreSelected.value === 3"
                        style="color: red"
                        >*</span
                      >
                      <b-form-input
                        :state="validator['CENT_DATFAB']"
                        onfocus="(this.type='date')"
                        onBlur="(this.type='text')"
                        type="text"
                        ref="inputDATFAB"
                        v-model="enregistrement.CENT_DATFAB"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>
                        Délai de mise en analyse
                        <span style="color: red">*</span>
                      </h6>
                      <multiselect
                        v-model="typeAnalysePreSelected"
                        :options="typesAnalyses"
                        selectLabel="Entrée : sélectionner"
                        selectedLabel="Sélectionné"
                        deselectLabel="Entrée : supprimer"
                        label="lib"
                        track-by="lib"
                      >
                        <template slot="singleLabel" slot-scope="{ option }"
                          ><span>{{ option.lib }}</span></template
                        >
                      </multiselect>
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>
                        J+
                        <span
                          v-if="typeAnalysePreSelected.value === 3"
                          style="color: red"
                          >*</span
                        >
                      </h6>
                      <b-form-input
                        :state="validator['CENT_NBJ']"
                        placeholder="J +"
                        v-model="enregistrement.CENT_NBJ"
                        :disabled="typeAnalysePreSelected.value === 1"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3">
                    <b-form-group>
                      <h6>DLC</h6>
                      <span
                        v-if="typeAnalysePreSelected.value === 2"
                        style="color: red"
                        >*</span
                      >
                      <b-form-input
                        onfocus="(this.type='date')"
                        onBlur="(this.type='text')"
                        type="text"
                        ref="inputDATDLC"
                        v-model="enregistrement.CENT_DATDLC"
                        :state="validator['CENT_DATDLC']"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="12">
                    <b-form-group
                      :description="descCom(enregistrement.CENT_TXT4, 75)"
                    >
                      <h6>Commentaires</h6>
                      <b-form-input
                        maxlength="75"
                        v-model="enregistrement.CENT_TXT4"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" lg="3" v-if="modeEdition !== 'edit' || isSac">
                    <b-form-group>
                      <h6>Nombre échantillons similaires</h6>
                      <b-form-input
                        type="number"
                        min="1"
                        v-model.number="nbEchantillonSimilaires"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    md="3"
                    lg="3"
                    v-if="echantillonMoyennDisplay && (modeEdition !== 'edit' || isSac)"
                  >
                    <b-form-group>
                      <h6>Echantillon moyen</h6>
                      <div>
                        <b-form-checkbox
                          switch
                          size="lg"
                          v-model="checkedEchantillonMoyen"
                          name="check-button"
                          :disabled="echantillonMoyennDisabled"
                        >
                        </b-form-checkbox>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col
                    md="3"
                    lg="3"
                    v-if="echantillonMoyennDisplay && (modeEdition !== 'edit' || isSac)"
                  >
                    <b-form-group>
                      <h6>1 rapport par échantillon</h6>
                      <div>
                        <b-form-checkbox
                          switch
                          size="lg"
                          v-model="checked1RapportEch"
                          name="check-button"
                          :disabled="echantillonMoyennDisabled"
                        >
                        </b-form-checkbox>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-form>
          </b-card>
        </tab-content>
        <tab-content
          title="Commentaire Labo"
          icon="fas fa-comment"
          v-if="isSac"
        >
          <div>
            <b-row>
              <b-col>
                <CommentaireLabo ref="commentaireLabo" origineCom="LABO"/>
              </b-col>
            </b-row>
          </div>
        </tab-content>
        <tab-content
          title="Commentaire Client"
          icon="fas fa-comment"
          v-if="isSac"
        >
          <div>
            <b-row>
              <b-col>
                <CommentaireLabo ref="commentaireClient" origineCom="CLIENT"/>
              </b-col>
            </b-row>
          </div>
        </tab-content>
        <tab-content
          title="Analyses"
          icon="fas fa-cogs"
          :before-change="postAnalyseStorage"
        >
          <div>
            <b-row>
              <b-col>
                <SelectedAnalysesComponent
                  :items="seriesAnalyses"
                  v-model="analysesSelected"
                ></SelectedAnalysesComponent>
              </b-col>
            </b-row>
          </div>
        </tab-content>

        <tab-content
          v-if="checkedEchantillonMoyen"
          title="Analyses sur l échantillon moyen"
          icon="fas fa-cogs"
          :before-change="postAnalyseMoyenStorage"
        >
          <div>
            <b-row>
              <b-col>
                <SelectedAnalysesComponent
                  :items="seriesAnalyses"
                  v-model="analysesMoyenSelected"
                ></SelectedAnalysesComponent>
              </b-col>
            </b-row>
          </div>
        </tab-content>

        <!-- Le composant est répéter deux fois pour gérer l'onglet de l'échantillon moyen -->
        <tab-content
          v-if="!checkedEchantillonMoyen"
          title="Confirmation"
          icon="fas fa-check"
        >
          <ConfirmationEchantillonComponent
            :items="recapEnregistrement"
          ></ConfirmationEchantillonComponent>
        </tab-content>

        <tab-content
          v-if="checkedEchantillonMoyen"
          title="Confirmation"
          icon="fas fa-check"
        >
          <ConfirmationEchantillonComponent
            :items="recapEnregistrement"
          ></ConfirmationEchantillonComponent>
        </tab-content>
      </form-wizard>

      <b-overlay :show="overlayAnalysesSelected" no-wrap>
        <template #overlay>
          <div tabindex="-1" role="dialog" class="text-center p-3">
            <p>
              <strong id="form-confirm-label">
                Êtes-vous sûr, il n'y a aucune analyse sélectionnée !
              </strong>
            </p>
            <div class="d-flex">
              <b-button
                variant="outline-success"
                class="mr-3"
                @click="overlayAnalysesSelectedCancel"
              >
                J'ajoute des analyses
              </b-button>
              <b-button
                variant="outline-danger"
                @click="overlayAnalysesSelectedOk"
                >Oui, je n'ai pas trouvé d'analyse</b-button
              >
            </div>
          </div>
        </template>
      </b-overlay>

      <template #overlay>
        <div class="text-center">
          <h5 v-if="nbRequestRecord">Enregistrement en cours</h5>
          <h5 v-else>Chargement en cours</h5>
          <b-spinner class="color_green_labco" type="grow" />
        </div>
      </template>
    </b-overlay>
  </b-container>
</template>
<script>

import api from './../api.js'
import { FormWizard, TabContent } from 'vue-form-wizard'
import Multiselect from 'vue-multiselect'
import SelectedAnalysesComponent from './SelectedAnalysesComponent.vue'
import ConfirmationEchantillonComponent from './ConfirmationEchantillonComponent.vue'
import CommentaireLabo from './CommentaireLabo.vue'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import moment from 'moment'

export default {
  name: 'DetailEchantillonComponent',
  props: ['modeEdition', 'itemEdit', 'numRapport'],
  data () {
    return {
      validator: {
        'CENT_CLT': null,
        'CENT_LIB': null,
        'CENT_PRD': null,
        'CENT_FAM': null,
        'CENT_DATPRLT': null,
        'CENT_DATSOUHAIT': null,
        'CENT_NBJ': null,
        'CENT_DATDLC': null,
        'CENT_DATFAB': null
      },
      changeClient: false,
      isSac: this.$root.user.login === 907 || this.$root.user.login === 9999,
      clients: [],
      selectedClient: null,
      clientSelected: null,
      checksChamp: ['CENT_LIB', 'CENT_CLT', 'CENT_PRD', 'CENT_FAM', 'CENT_DATPRLT', 'CENT_DATSOUHAIT', 'CENT_NBJ', 'CENT_DATDLC'],
      productPreSelected: null,
      productDataSelected: '',
      checkedEchantillonMoyen: false,
      checked1RapportEch: false,
      numRapportSelected: null,
      listNumRapport: [],
      canAddClient: true,
      canAddFournisseur: true,
      productsForEchantillon: [],
      familiesForEchantillon: [],
      libelleEchantillon: [],
      enregistrement: {},
      enregistrements: [],
      itemsAnalyse: [],
      analyse: {},
      analysePreSelected: null,
      analysesList: [],
      analysesListSelected: [],
      analysesSelected: [],
      overlayAnalysesSelected: false,
      serieAnalysesSelected: [],
      products: [],
      seriesAnalyses: [],
      selected: {
        analyses: [],
        seriesAnalyses: [],
        analysesSelected: []
      },
      idFamily: 8,
      familyDataPreSelected: null,
      typeAnalysePreSelected: { value: 1, lib: 'jour' },
      families: [],
      filter: null,
      loading: true,
      filterSelected: null,
      echantillonNum: null,
      valid: false,
      nbEchantillonSimilaires: 1,
      typesAnalyses: [
        { value: 1, lib: 'jour' },
        { value: 2, lib: 'DLC' },
        { value: 3, lib: 'J+' }
      ],
      recapEnregistrement: [],
      itemsRefClient: [],
      itemsRefFournisseur: [],
      middleEchantillon: false,
      nbRequestRecord: 0,
      close: false,
      fields: [{
        key: 'ANA_NUM',
        label: 'Ref'
      },
      {
        key: 'ANA_LIB',
        label: ''
      }
      ],
      fieldsSeriesAnalyses: [
        {
          key: 'SER_LIB',
          label: `Série d'analyses`
        }
      ],
      analysesMoyenSelected: []
    }
  },
  components: {
    FormWizard,
    TabContent,
    Multiselect,
    SelectedAnalysesComponent,
    CommentaireLabo,
    ConfirmationEchantillonComponent
  },
  mounted: function () {
    const vm = this

    vm.loading = true

    if (vm.$root.user.COR_WEB_CLT === 1) {
      vm.canAddClient = true
    }
    if (vm.$root.user.COR_WEB_FRS === 1) {
      vm.canAddFournisseur = true
    }

    if (vm.isSac) {
      api.getAllSacCustomers()
        .done((data) => {
          vm.clients = data.customers.map((client) => {
            return {
              login: client.CLT_NUM,
              fullName: client.CLT_RSO
            }
          })
          // Récupérer le dernier client utilisé et le placer en haut de la liste
          const lastCustomer = sessionStorage.getItem('lastCustomer')
          if (lastCustomer) {
            try {
              const parsedLastCustomer = JSON.parse(lastCustomer)
              // Trouver le client dans la liste
              const clientIndex = vm.clients.findIndex(client => client.login === parsedLastCustomer.login)
              if (clientIndex > -1) {
                // Retirer le client de sa position actuelle
                const client = vm.clients.splice(clientIndex, 1)[0]
                // L'ajouter en première position
                vm.clients.unshift(client)
              }
            } catch (e) {
              console.warn('Erreur lors de la récupération du dernier client:', e)
            }
          }
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
    }

    const requests = []
    requests.push(api.getProductsGenerikByClient(vm.$root.user.login)
      .done((data) => {
        let pData = data.productsGenerik
        pData.forEach(element => {
          let dObject = {
            CWL_FAM: element.CWL_FAM,
            CWL_PDT: element.CWL_PDT,
            fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
            CWL_NUM: element.CWL_NUM,
            CWL_LIB: element.CWL_LIB.trim(),
            ID_ANALYSES: element.ID_ANALYSES,
            nbrEchantillon: ''
          }
          vm.libelleEchantillon.push(dObject)
        })
      })
      .fail(function (xhr) {
        window.fail(xhr, true)
      }))

    requests.push(api.getFamilyByClient(vm.$root.user.login)
      .done((data) => {
        let pData = data.family
        pData.forEach(element => {
          let dObject = {
            fullName: element.CFAM_LIB,
            CFAM_FAM: element.CFAM_FAM,
            CFAM_LIB: element.CFAM_LIB
          }
          vm.families.push(dObject)
          vm.familiesForEchantillon = vm.families
          vm.familiesForEchantillon.sort((a, b) => a.CFAM_LIB - b.CFAM_LIB)
        })
      })
      .fail(function (xhr) {
        window.fail(xhr, true)
      }))

    requests.push(api.getProductsByClient(vm.$root.user.login)
      .done((data) => {
        let pData = data.products
        pData.forEach(element => {
          let dObject = {
            fullName: element.CPRD_LIB,
            CPRD_PRD: element.CPRD_PRD,
            CPRD_LIB: element.CPRD_LIB,
            CPRD_CPRD: element.CPRD_CPRD
          }
          vm.products.push(dObject)
          vm.productsForEchantillon = vm.products
          vm.productsForEchantillon.sort((a, b) => a.CPRD_PRD - b.CPRD_PRD)
        })
      })
      .fail(function (xhr) {
        window.fail(xhr, true)
      }))

    requests.push(api.getRefClient()
      .done((data) => {
        vm.itemsRefClient = data.data
      })
      .fail(function (xhr) {
        window.fail(xhr, true)
      }))

    requests.push(api.getRefFournisseur()
      .done((data) => {
        vm.itemsRefFournisseur = data.data
      })
      .fail(function (xhr) {
        window.fail(xhr, true)
      }))

    requests.push(vm.getAnalyses())

    requests.push(vm.getFinalListRapport())

    vm.clearForm()

    Promise.all(requests).then(() => {
      if (vm.itemEdit !== null) {
        vm.buildItemEdit()
      } else if (vm.isSac) {
        // Préselectionner le dernier client utilisé en mode SAC
        vm.preselectLastCustomer()
      }

      vm.loading = false
    })
  },
  methods: {
    customLabel (option) {
      return `${option.fullName} (${option.login})`
    },
    onClientSelected (selected) {
      if (selected) {
        this.clientSelected = selected.login
        this.getSacData()
      } else {
        this.clientSelected = null
      }
    },
    preselectLastCustomer () {
      const vm = this
      const lastCustomer = sessionStorage.getItem('lastCustomer')
      if (lastCustomer) {
        try {
          const parsedLastCustomer = JSON.parse(lastCustomer)
          // Trouver et sélectionner le dernier client utilisé
          const client = vm.clients.find(client => client.login === parsedLastCustomer.login)
          if (client) {
            vm.selectedClient = client
            vm.onClientSelected(client)
          }
        } catch (e) {
          console.warn('Erreur lors de la présélection du dernier client:', e)
        }
      }
    },
    getFinalListRapport () {
      const vm = this
      return api.getNummRapportClient()
        .done((data) => {
          vm.listNumRapport = data.data
          if (vm.modeEdition === 'create') {
            setTimeout(() => {
              let max = Math.max(0, ...vm.listNumRapport)
              vm.listNumRapport.unshift(max + 1)
              vm.numRapportSelected = max + 1
            }, 0)
          }
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
    },
    verifAndSetAnalyse (prevIndex, nextIndex) {
      if (nextIndex === 1 && sessionStorage.getItem('analyses')) {
        this.analysesSelected = JSON.parse(sessionStorage.getItem('analyses'))
      }
      if (nextIndex === 2 && this.checkedEchantillonMoyen && sessionStorage.getItem('analysesMoyen')) {
        this.analysesMoyenSelected = JSON.parse(sessionStorage.getItem('analysesMoyen'))
      }
      if (this.$refs.commentaireLabo) {
        this.$refs.commentaireLabo.logFieldValues()
      }
    },
    autoCompleteForm () {
      const vm = this

      vm.enregistrement.CENT_LIB = vm.analysePreSelected.trim()

      let product = vm.libelleEchantillon.find((lib) => {
        return lib.fullName === vm.analysePreSelected
      })
      // Si pas trouvé par fullName (probablement à cause du maxlength),
      // essayer de trouver par le début du fullName (CWL_NUM + espace)
      if (!product) {
        product = vm.libelleEchantillon.find((lib) => {
          return vm.analysePreSelected.startsWith(lib.CWL_NUM + ' ')
        })
      }

      if (product) {
        vm.productPreSelected = product

        setTimeout(() => {
          vm.analysePreSelected = product.CWL_LIB
        }, 0)

        vm.enregistrement.CENT_LIB = product.CWL_LIB

        vm.productDataSelected = this.products.find((item) => {
          return item.CPRD_PRD === product.CWL_PDT
        })

        this.familyDataPreSelected = this.families.find((item) => {
          return item.CFAM_FAM === product.CWL_FAM
        })

        vm.preSelectCurrentAnalyse()
      }
    },
    checkStateModel (e) {
      if ((e.target.value).length > 0) {
        return true
      }
      return false
    },
    postEnregistrementStorage () {
      if (this.modeEdition === 'edit') {
        this.productPreSelected.ID_ANALYSES = this.enregistrement.ANALYSES
      }
      this.valid = true
      this.checksChamp.forEach((chk) => {
        if (!this.enregistrement[chk] || this.enregistrement[chk] === '') {
        // console.log(`condition: ${!this.enregistrement[chk] || this.enregistrement[chk] === ''} dans ${chk} où ${this.enregistrement[chk]}`)
          this.valid = false
          this.validator[chk] = false
        } else {
          this.validator[chk] = true
        }

        if (this.valid === false) {
          console.log('error on', chk)
        }
      })

      if (typeof this.enregistrement.CENT_DATPRLT === 'undefined' || moment(this.enregistrement.CENT_DATPRLT).isValid() === false) {
        this.valid = false
        this.validator['CENT_DATPRLT'] = false
      }

      if (typeof this.enregistrement.CENT_DATSOUHAIT === 'undefined' || moment(this.enregistrement.CENT_DATSOUHAIT).isValid() === false) {
        this.valid = false
        this.validator['CENT_DATSOUHAIT'] = false
      }

      if (this.enregistrement.CENT_TYP === 2 && (typeof this.enregistrement.CENT_DATDLC === 'undefined' || moment(this.enregistrement.CENT_DATDLC).isValid() === false)) {
        this.valid = false
        this.validator['CENT_DATDLC'] = false
      }

      if (!this.isSac) {
        this.valid = true
        this.validator['CENT_CLT'] = true
        this.clientSelected = this.$root.user.login
      } else if (!this.clientSelected) {
        this.valid = false
        this.validator['CENT_CLT'] = false
      } else {
        this.validator['CENT_CLT'] = true
      }

      this.validator['CENT_DATFAB'] = null
      if (this.enregistrement.CENT_TYP === 3) {
        if (typeof this.enregistrement.CENT_NBJ === 'undefined' || this.enregistrement.CENT_NBJ === '') {
          this.valid = false
          this.validator['CENT_NBJ'] = false
        }

        if (!this.enregistrement.CENT_DATFAB || this.enregistrement.CENT_DATFAB === '') {
          this.valid = false
          this.validator['CENT_DATFAB'] = false
        } else {
          this.validator['CENT_DATFAB'] = true
        }
      }
      if (this.valid === true) {
        if (this.isSac) {
          this.enregistrement.idClient = this.clientSelected
        } else {
          this.enregistrement.idClient = this.$root.user.login
        }
        this.enregistrement.fullNameProduct = this.productDataSelected.fullName
        this.enregistrement.fullNameFamily = this.familyDataPreSelected.fullName
        sessionStorage.setItem('enregistrement', JSON.stringify(this.enregistrement))
        this.enregistrements.push(this.enregistrement)
        return true
      } else {
        return false
      }
    },
    postEnregistrementBddAsync (typeAnalyse = 'analyses', skipAnalyses = false, forceCreate = false) {
      return new Promise((resolve) => {
        const vm = this
        let apiMethod = api.putEnregistrement
        if (vm.modeEdition === 'create' || forceCreate) {
          apiMethod = api.postEnregistrement
        }
        vm.nbRequestRecord++
        // Build payload from sessionStorage so we can tweak it for special cases
        let payload = JSON.parse(sessionStorage.getItem('enregistrement'))
        // Normaliser les dates dans les commentaires avant l'envoi
        payload = this.prepareCommentFieldsForSubmission(payload)
        // If we're posting the "analysesMoyen" type, remove CENT_FORFAIT if present
        if (typeAnalyse === 'analysesMoyen' && payload && Object.prototype.hasOwnProperty.call(payload, 'CENT_FORFAIT')) {
          delete payload.CENT_FORFAIT
        }
        apiMethod(payload)
          .done(data => {
            if (data && data.echantillonNum) {
              vm.echantillonNum = data.echantillonNum
            }
            // Ne poster les analyses que si on ne skip pas (i>1 en mode édition ou mode création)
            if (!skipAnalyses) {
              vm.postAnalyseBdd(typeAnalyse)
            }
            resolve()
          })
          .fail((xhr) => {
            window.fail(xhr, true)
            vm.close = false
            resolve()
          })
          .always(() => {
            vm.nbRequestRecord--
          })
      })
    },
    postAnalyseStorage () {
      if (this.analysesSelected.length === 0 && this.overlayAnalysesSelected === false) {
        this.overlayAnalysesSelected = true

        return false
      }
      this.recapEnregistrement = []
      sessionStorage.setItem('analyses', JSON.stringify(this.analysesSelected))
      let enr = JSON.parse(sessionStorage.getItem('enregistrement'))
      for (var i = 1; i <= this.nbEchantillonSimilaires; i++) {
        let libelleTo = enr.CENT_LIB
        if ((this.nbEchantillonSimilaires) > 1) {
          libelleTo = enr.CENT_LIB + ' n° ' + i
        }
        if (this.modeEdition === 'edit') {
          libelleTo = enr.CENT_LIB
        }
        let recap = {
          indexRecap: i,
          isMoyen: false,
          libelle: libelleTo,
          analyses: (this.analysesSelected)
        }
        this.$set(this.recapEnregistrement, i, recap)
      }
      // if (this.checkedEchantillonMoyen) {
      //   this.analysesSelected = []
      // }
      return true
    },
    overlayAnalysesSelectedCancel: function () {
      const vm = this

      vm.overlayAnalysesSelected = false
    },
    overlayAnalysesSelectedOk: function () {
      const vm = this

      vm.$refs.stepWizard.nextTab()

      vm.overlayAnalysesSelected = false
    },
    postAnalyseMoyenStorage () {
      if (this.analysesMoyenSelected.length === 0 && this.overlayAnalysesSelected === false) {
        this.overlayAnalysesSelected = true
        return false
      }
      sessionStorage.setItem('analysesMoyen', JSON.stringify(this.analysesMoyenSelected))
      let enr = JSON.parse(sessionStorage.getItem('enregistrement'))
      let recap = {
        indexRecap: null,
        isMoyen: true,
        libelle: enr.CENT_LIB + ' - EM',
        analyses: this.analysesMoyenSelected
      }
      if (this.recapEnregistrement[this.nbEchantillonSimilaires + 1]) {
        this.$set(this.recapEnregistrement, this.nbEchantillonSimilaires + 1, recap)
      } else {
        this.recapEnregistrement.push(recap)
      }
      return true
    },
    postAnalyseBdd (typeAna = 'analyses') {
      const vm = this
      const enregistrement = JSON.parse(sessionStorage.getItem('enregistrement'))
      const analyses = JSON.parse(sessionStorage.getItem(typeAna))

      analyses.forEach(analyse => {
        if (vm.isSac) {
          vm.analyse.idCustomer = vm.clientSelected
        } else {
          vm.analyse.idCustomer = vm.$root.user.login
        }
        vm.analyse.numSample = vm.echantillonNum
        vm.analyse.idAnalysis = analyse.ANA_NUM
        if ('CENT_RECORD' in enregistrement && enregistrement.CENT_RECORD !== null) {
          vm.analyse.dateRecord = enregistrement.CENT_RECORD
        }
        vm.nbRequestRecord++
        api.postAnalyse({
          data: vm.analyse
        }).always(() => {
          vm.nbRequestRecord--
        })
      })
    },
    getSacSeriesAnalyses (userLogin, family) {
      const vm = this
      return api.getSeriesAnalysesSac(userLogin, family)
        .done((data) => {
          let allIds = []
          data.data.forEach(serie => {
            if (Array.isArray(serie.ID_ANALYSES)) {
              allIds = allIds.concat(serie.ID_ANALYSES)
            }
          })
          allIds = [...new Set(allIds)]
          const analysesForTous = vm.analysesList.filter(ana => allIds.includes(ana.ANA_NUM))
          const series = []
          if (analysesForTous.length > 0) {
            series.push({ SER_NUM: 0, SER_LIB: 'Tous', ID_ANALYSES: allIds, analyses: analysesForTous })
          }
          // Permet de rajouter les analyses sur les series
          data.data.map((serie) => {
            serie.analyses = vm.analysesList.filter((ana) => {
              return serie.ID_ANALYSES.indexOf(ana.ANA_NUM) !== -1
            })
          })
          vm.seriesAnalyses = series.concat(data.data)
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
    },
    getSeriesAnalyses () {
      const vm = this
      return api.getSeriesAnalyses()
        .done((data) => {
          vm.seriesAnalyses = [{ SER_NUM: 0, SER_LIB: 'Tous', analyses: [...vm.analysesList] }]
          // Permet de rajouter les analyses sur les series
          data.data.map((serie) => {
            serie.analyses = vm.analysesList.filter((ana) => {
              return serie.ID_ANALYSES.indexOf(ana.ANA_NUM) !== -1
            })
          })
          vm.seriesAnalyses = vm.seriesAnalyses.concat(data.data)
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
    },
    getAnalyses () {
      const vm = this

      return api.getAnalysesByClient()
        .done(function (data) {
          if (data.analyses.length) {
            vm.analysesList = data.analyses
            if (!vm.isSac) { // ne charger les série que si l'on n'est pas SAC
              vm.getSeriesAnalyses()
            }
          }
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
    },
    confirmation () {
      const vm = this

      let nbrEchanTotal = vm.nbEchantillonSimilaires
      if (nbrEchanTotal < 1) {
        return
      }

      if (vm.checkedEchantillonMoyen) {
        nbrEchanTotal++
      }

      vm.loadingRecord = true

      vm.close = true
      let preleveurAjoute = false
      // Mode édition SAC : déterminer si on modifie simplement ou si on ajoute des échantillons
      // Pour avoir un moyen, il faut au minimum nbEchantillonSimilaires >= 2
      const isSimpleEdit = (vm.modeEdition === 'edit' && vm.isSac && vm.nbEchantillonSimilaires === 1)
      const isEditWithAdditions = (vm.modeEdition === 'edit' && vm.isSac && vm.nbEchantillonSimilaires > 1)
      // Créer un tableau de tâches à exécuter séquentiellement
      const tasks = []
      for (var i = 1; i <= nbrEchanTotal; i++) {
        tasks.push({ index: i, nbrEchanTotal: nbrEchanTotal })
      }
      // Exécuter les tâches séquentiellement
      let promise = Promise.resolve()
      tasks.forEach((task) => {
        const i = task.index
        promise = promise.then(() => {
          return new Promise((resolve) => {
            let enregistrement = {}
            if (sessionStorage.getItem('enregistrement')) {
              enregistrement = JSON.parse(sessionStorage.getItem('enregistrement'))
            }
            enregistrement.CENT_LIB = vm.recapEnregistrement[i].libelle
            if (
              vm.recapEnregistrement[i].commentaire !== null &&
              vm.recapEnregistrement[i].commentaire !== '' &&
              vm.recapEnregistrement[i].commentaire !== undefined
            ) {
              if (enregistrement.CENT_COMMENT_APPLI_LABO) {
                enregistrement.CENT_COMMENT_APPLI_LABO += ' |Commentaire : ' + vm.recapEnregistrement[i].commentaire
              } else {
                enregistrement.CENT_COMMENT_APPLI_LABO = vm.recapEnregistrement[i].commentaire
              }
            }
            // Ajouter automatiquement l'agent préleveur en mode SAC
            if (vm.isSac && vm.$root.user.nom) {
              const agentPreleveur = `Agent préleveur : ${vm.$root.user.nom}`
              if (enregistrement.CENT_COMMENT_APPLI_LABO) {
                if (!preleveurAjoute) {
                  // Vérifier si un agent préleveur existe déjà et le remplacer
                  if (enregistrement.CENT_COMMENT_APPLI_LABO.match(/Agent préleveur\s*:\s*[^|]*/i)) {
                    // Remplacer l'ancien agent préleveur par le nouveau
                    enregistrement.CENT_COMMENT_APPLI_LABO = enregistrement.CENT_COMMENT_APPLI_LABO.replace(/\|?\s*Agent préleveur\s*:\s*[^|]*(\||$)/gi, `|${agentPreleveur}`)
                  } else {
                    // Ajouter le nouvel agent préleveur s'il n'existe pas
                    enregistrement.CENT_COMMENT_APPLI_LABO += `|${agentPreleveur}`
                  }
                  preleveurAjoute = true
                }
              } else {
                enregistrement.CENT_COMMENT_APPLI_LABO = `|${agentPreleveur}`
                preleveurAjoute = true
              }
            }
            if (vm.checked1RapportEch) {
              if (i > 1) {
                vm.enregistrement.CENT_NRAP++
                enregistrement.CENT_NRAP++
              }
            }
            sessionStorage.setItem('enregistrement', JSON.stringify(enregistrement))
            // En mode édition SAC : gérer la mise à jour vs création
            let skipAnalysesPost = false
            let forceCreate = false

            // CAS 1 : Modification simple (nb=1, pas de moyen) - Supprimer et recréer l'échantillon
            if (isSimpleEdit && i === 1) {
              const dateRecord = vm.itemEdit.CENT_RECORD
              const echantillonNum = vm.itemEdit.CENT_NUM
              const clientId = vm.itemEdit.CENT_CLT
              // Sauvegarder les données de l'échantillon avant suppression
              const savedEnregistrement = JSON.parse(JSON.stringify(enregistrement))
              const savedAnalyses = sessionStorage.getItem('analyses')

              api.deleteEchantillonSac(dateRecord, echantillonNum, clientId)
                .done(() => {
                  // Restaurer les données sauvegardées
                  delete savedEnregistrement.CENT_NUM
                  delete savedEnregistrement.CENT_RECORD
                  sessionStorage.setItem('enregistrement', JSON.stringify(savedEnregistrement))
                  sessionStorage.setItem('analyses', savedAnalyses)
                  // Créer une promise pour attendre la fin de postEnregistrementBdd
                  vm.postEnregistrementBddAsync('analyses', false, true).then(resolve)
                })
                .fail(function (xhr) {
                  window.fail(xhr, true)
                  vm.close = false
                  resolve()
                })
              return
            }

            // CAS 2 : Modification avec ajout d'échantillons (nb>1 ou moyen)
            if (isEditWithAdditions) {
              if (i === 1) {
                // i=1 : supprimer et recréer l'échantillon de base
                const dateRecord = vm.itemEdit.CENT_RECORD
                const echantillonNum = vm.itemEdit.CENT_NUM
                const clientId = vm.itemEdit.CENT_CLT
                // Sauvegarder les données de l'échantillon avant suppression
                const savedEnregistrement = JSON.parse(JSON.stringify(enregistrement))
                const savedAnalyses = sessionStorage.getItem('analyses')

                api.deleteEchantillonSac(dateRecord, echantillonNum, clientId)
                  .done(() => {
                    // Restaurer les données sauvegardées
                    delete savedEnregistrement.CENT_NUM
                    delete savedEnregistrement.CENT_RECORD
                    sessionStorage.setItem('enregistrement', JSON.stringify(savedEnregistrement))
                    sessionStorage.setItem('analyses', savedAnalyses)
                    // Créer une promise pour attendre la fin de postEnregistrementBdd
                    vm.postEnregistrementBddAsync('analyses', false, true).then(resolve)
                  })
                  .fail(function (xhr) {
                    window.fail(xhr, true)
                    vm.close = false
                    resolve()
                  })
                return
              } else {
                // i>1 : créer de nouveaux échantillons (duplications ou moyen)
                let newEnregistrement = JSON.parse(sessionStorage.getItem('enregistrement'))
                delete newEnregistrement.CENT_NUM
                delete newEnregistrement.CENT_RECORD
                sessionStorage.setItem('enregistrement', JSON.stringify(newEnregistrement))
                forceCreate = true
              }
            }
            // si on vient d'enregistrer le dernier échantillon et qu'il y a un ech moyen
            if (i === (nbrEchanTotal) && vm.checkedEchantillonMoyen) {
              vm.postEnregistrementBddAsync('analysesMoyen', skipAnalysesPost, forceCreate).then(resolve)
            } else {
              vm.postEnregistrementBddAsync('analyses', skipAnalysesPost, forceCreate).then(resolve)
            }
          })
        })
      })

      // Quand tout est fini
      promise.then(() => {
        if (vm.close) {
          // Sauvegarder le dernier client utilisé en mode SAC
          if (vm.isSac && vm.selectedClient) {
            sessionStorage.setItem('lastCustomer', JSON.stringify(vm.selectedClient))
          }
          window.vm.$bvToast.toast(`L'enregistrement a été effectué`, {
            title: `Succès`,
            variant: 'success',
            solid: true
          })
          vm.closeForm()
        }
      })
    },
    findFamily (FAM) {
      let family = {}
      this.families.forEach((fam) => {
        if (fam.CFAM_FAM === FAM) family = fam
      })
      return family
    },
    findTypeAnalyse (typ) {
      let type = {}
      this.typesAnalyses.forEach((tp) => {
        if (tp.value === typ) type = tp
      })
      return type
    },
    closeForm () {
      const vm = this

      vm.close = true
      if (vm.nbRequestRecord === 0) {
        global.model1.hide()
      }
    },
    clearForm () {
      this.enregistrement = {
        CENT_DATPRLT: moment().format('YYYY-MM-DD'),
        CENT_DATSOUHAIT: this.isSac ? moment().format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD'),
        CENT_CECH: null,
        CENT_COD_CLT: null,
        CENT_DATDLC: null,
        CENT_DATFAB: null,
        CENT_FAM: null,
        CENT_LIB: null,
        CENT_NBJ: null,
        CENT_NRAP: null,
        CENT_PRD: null,
        CENT_TXT1: null,
        CENT_TXT2: null,
        CENT_TXT3: null,
        CENT_TXT4: null,
        CENT_TYP: null,
        CPRD_CPRD: null,
        CENT_CLT: null
      }
      sessionStorage.removeItem('analysesMoyen')
      sessionStorage.removeItem('analyses')
      this.nbEchantillonSimilaires = 1
      this.checkedEchantillonMoyen = false
      this.checked1RapportEch = false
      this.analysePreSelected = ''
      this.clientSelected = null
      this.productDataSelected = ''
      this.familyDataPreSelected = null
      this.productPreSelected = {}
      this.typeAnalysePreSelected = { value: 1, lib: 'jour' }
      this.middleEchantillon = false
      this.$refs.stepWizard.reset()
    },
    preSelectAnalyse () {
      this.analysesSelected = []
      this.analysesList.forEach((analyse) => {
        if (this.productPreSelected.ID_ANALYSES != null) {
          this.productPreSelected.ID_ANALYSES.forEach((idAnalyse) => {
            if (analyse.ANA_NUM === idAnalyse) {
              this.analysesSelected.push(analyse)
            }
          })
        }
      })
    },
    preSelectCurrentAnalyse () {
      this.analysesSelected = []
      for (const analyse of this.analysesList) {
        if (this.productPreSelected.ID_ANALYSES != null) {
          for (const idAnalyse of this.productPreSelected.ID_ANALYSES) {
            if (analyse.ANA_NUM === idAnalyse) {
              this.analysesSelected.push(analyse)
            }
          }
        }
      }
    },
    getSacData () {
      const vm = this
      vm.families = []
      vm.familiesForEchantillon = []
      vm.libelleEchantillon = []
      vm.familyDataPreSelected = []
      vm.analysePreSelected = ''
      vm.seriesAnalyses = []
      vm.productsForEchantillon = []
      vm.productDataSelected = ''
      vm.products = []
      // vm.getSeriesAnalyses()
      if (vm.$root.user.login === 907 || vm.$root.user.login === 9999) {
        let userlogin = vm.$root.user.login
        console.log(vm.clientSelected)
        vm.enregistrement['CENT_CLT'] = vm.clientSelected
        api.getFamilyByClient(userlogin)
          .done((data) => {
            let pData = data.family
            pData.forEach(element => {
              let dObject = {
                fullName: element.CFAM_LIB,
                CFAM_FAM: element.CFAM_FAM,
                CFAM_LIB: element.CFAM_LIB
              }
              vm.families.push(dObject)
              vm.familiesForEchantillon = vm.families
              vm.familiesForEchantillon.sort((a, b) => a.CFAM_LIB - b.CFAM_LIB)
            })
          })
          .fail(function (xhr) {
            window.fail(xhr, true)
          })
        api.getProductsGenerikByClient(userlogin)
          .done((data) => {
            let pData = data.productsGenerik
            pData.forEach(element => {
              let dObject = {
                CWL_FAM: element.CWL_FAM,
                CWL_PDT: element.CWL_PDT,
                fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
                CWL_NUM: element.CWL_NUM,
                CWL_LIB: element.CWL_LIB.trim(),
                ID_ANALYSES: element.ID_ANALYSES,
                nbrEchantillon: ''
              }
              vm.libelleEchantillon.push(dObject)
            })
          })
          .fail(function (xhr) {
            window.fail(xhr, true)
          })
        api.getProductsByClient(userlogin)
          .done((data) => {
            let pData = data.products
            pData.forEach(element => {
              let dObject = {
                fullName: element.CPRD_LIB,
                CPRD_PRD: element.CPRD_PRD,
                CPRD_LIB: element.CPRD_LIB,
                CPRD_CPRD: element.CPRD_CPRD
              }
              vm.products.push(dObject)
              vm.productsForEchantillon = vm.products
              vm.productsForEchantillon.sort((a, b) => a.CPRD_PRD - b.CPRD_PRD)
            })
          })
          .fail(function (xhr) {
            window.fail(xhr, true)
          })
      }
    },
    buildItemEdit: function () {
      const vm = this
      this._isInitializingEdit = true

      vm.enregistrement = Object.assign({}, vm.itemEdit)

      // En mode SAC, ajuster la date de réception à aujourd'hui
      if (vm.isSac) {
        vm.enregistrement.CENT_DATSOUHAIT = moment().format('YYYY-MM-DD')
      }

      vm.clientSelected = vm.enregistrement.CENT_CLT
      vm.changeClient = true
      vm.echantillonNum = vm.enregistrement.CENT_NUM
      vm.numRapportSelected = vm.enregistrement.CENT_NRAP

      vm.analysePreSelected = vm.enregistrement.CENT_LIB
      vm.typeAnalysePreSelected = vm.typesAnalyses.filter((itm) => {
        return vm.enregistrement.CENT_TYP === itm.value
      })[0]

      let producttoslelect = vm.productsForEchantillon.filter((itm) => {
        return itm.CPRD_PRD === vm.enregistrement.CENT_PRD.PRD_NUM
      })[0]
      if (producttoslelect) {
        vm.productDataSelected = producttoslelect
      }
      let famtoslelect = vm.familiesForEchantillon.filter((itm) => {
        return itm.CFAM_FAM === vm.enregistrement.CENT_FAM.CFAM_FAM
      })[0]
      if (famtoslelect) {
        vm.familyDataPreSelected = famtoslelect
        vm.enregistrement.CENT_FAM = famtoslelect.CFAM_FAM // Correction ici : on met l'id, pas l'objet
      }

      if (vm.isSac && vm.familyDataPreSelected && vm.familyDataPreSelected.CFAM_FAM) { // Si on est en mode SAC, on charge les analyses de la famille
        vm.getSacSeriesAnalyses(vm.$root.user.login, vm.familyDataPreSelected.CFAM_FAM)
      }
      vm.analysesList.forEach((analyse) => {
        if (vm.enregistrement.ANALYSES != null) {
          vm.enregistrement.ANALYSES.forEach((idAnalyse) => {
            if (analyse.ANA_NUM === idAnalyse) {
              vm.analysesSelected.push(analyse)
            }
          })
        }
      })

      sessionStorage.setItem('analyses', JSON.stringify(vm.analysesSelected))
      if (this.isSac && vm.familyDataPreSelected && vm.familyDataPreSelected.CFAM_FAM) {
        const promises = []
        if (this.$refs.commentaireLabo) {
          const laboPromise = this.$refs.commentaireLabo.fetchFields(vm.familyDataPreSelected.CFAM_FAM)
          promises.push(laboPromise)
        }
        if (this.$refs.commentaireClient) {
          const clientPromise = this.$refs.commentaireClient.fetchFields(vm.familyDataPreSelected.CFAM_FAM)
          promises.push(clientPromise)
        }
        // Attendre que tous les champs soient chargés avant de pré-remplir
        Promise.all(promises).then(() => {
          vm.parseAndFillCommentFields()
        }).catch(error => {
          console.error('Erreur lors du chargement des champs dynamiques:', error)
        })
      }
      this.$nextTick(() => {
        this._isInitializingEdit = false
      })
    },
    descCom: function (text, nbCarateresMax = 75) {
      let nbCarateres = 0
      if (text) {
        nbCarateres = text.length
      }

      return `${nbCarateres} / ${nbCarateresMax} caractéres maximum`
    },
    parseAndFillCommentFields: function () {
      const vm = this
      // Parser les commentaires client (CENT_COMMENT_APPLI)
      if (vm.enregistrement.CENT_COMMENT_APPLI && vm.$refs.commentaireClient) {
        vm.parseCommentString(vm.enregistrement.CENT_COMMENT_APPLI, vm.$refs.commentaireClient)
      }
      // Parser les commentaires labo (CENT_COMMENT_APPLI_LABO) en ignorant l'agent préleveur
      if (vm.enregistrement.CENT_COMMENT_APPLI_LABO && vm.$refs.commentaireLabo) {
        // Filtrer l'agent préleveur avant de parser
        let commentLabo = vm.enregistrement.CENT_COMMENT_APPLI_LABO
        // Supprimer la partie "Agent préleveur : [nom]"
        commentLabo = commentLabo.replace(/\s*\|?\s*Agent préleveur\s*:\s*[^|]*(\||$)/gi, '')
        // Nettoyer les pipes en trop
        commentLabo = commentLabo.replace(/\|\s*\|/g, '|').replace(/^\|/, '').replace(/\|$/, '')
        if (commentLabo.trim()) {
          vm.parseCommentString(commentLabo, vm.$refs.commentaireLabo)
        }
      }
      // Charger le champ Forfait (CENT_FORFAIT) directement dans commentaireLabo
      if (vm.enregistrement.CENT_FORFAIT && vm.$refs.commentaireLabo) {
        vm.$refs.commentaireLabo.setFieldValue('Forfait', vm.enregistrement.CENT_FORFAIT)
      }
    },
    parseCommentString: function (commentString, componentRef) {
      if (!commentString || !componentRef) return
      // Diviser la chaîne par les pipes
      const parts = commentString.split('|')
      parts.forEach(part => {
        const trimmedPart = part.trim()
        if (!trimmedPart) return
        // Chercher le pattern "Clé: Valeur"
        const match = trimmedPart.match(/^(.+?)\s*:\s*(.+)$/)
        if (match) {
          const key = match[1].trim()
          const value = match[2].trim()
          // Essayer de remplir le champ correspondant dans le composant
          if (componentRef.setFieldValue && typeof componentRef.setFieldValue === 'function') {
            componentRef.setFieldValue(key, value)
          }
        }
      })
    },
    prepareCommentFieldsForSubmission (payload) {
      if (!payload || typeof payload !== 'object') {
        return payload
      }

      if (payload.CENT_COMMENT_APPLI_LABO) {
        payload.CENT_COMMENT_APPLI_LABO = this.formatCommentWithFrenchDates(payload.CENT_COMMENT_APPLI_LABO)
      }

      if (payload.CENT_COMMENT_APPLI) {
        payload.CENT_COMMENT_APPLI = this.formatCommentWithFrenchDates(payload.CENT_COMMENT_APPLI)
      }

      return payload
    },
    formatCommentWithFrenchDates (commentString) {
      if (!commentString || typeof commentString !== 'string') {
        return commentString
      }

      const parts = commentString.split('|')
      const formattedParts = parts
        .map(part => part.trim())
        .filter(Boolean)
        .map(part => {
          const match = part.match(/^(.+?:)\s*(.+)$/)
          if (!match) {
            return this.formatIsoDateValue(part)
          }
          const label = match[1]
          const value = match[2]
          const formattedValue = this.formatIsoDateValue(value)
          return `${label} ${formattedValue}`.trim()
        })

      // Format: '|valeur |valeur2 |valeur3 ' (pipe at start and before each value, space at end)
      return formattedParts.length > 0 ? '|' + formattedParts.join(' |') + ' ' : null
    },
    formatIsoDateValue (value) {
      if (!value || typeof value !== 'string') {
        return value
      }

      const trimmedValue = value.trim()

      const isoDateTimeMatch = trimmedValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?(?:Z)?$/)
      if (isoDateTimeMatch) {
        const [, year, month, day, hours = '00', minutes = '00'] = isoDateTimeMatch
        const formattedDate = `${day}/${month}/${year}`
        const timePart = `${hours}:${minutes}`
        return isoDateTimeMatch[4] ? `${formattedDate} ${timePart}` : formattedDate
      }

      return trimmedValue
    }
  },
  computed: {
    syncedFamilyData: {
      get () {
        return this.familyDataPreSelected
      },
      set (value) {
        this.familyDataPreSelected = value
      }
    },
    echantillonMoyennDisplay: function () {
      if (this.$root.user.roles.ECHMOY === 1) {
        return true
      }

      return false
    },
    echantillonMoyennDisabled: function () {
      if (this.nbEchantillonSimilaires > 1) {
        return false
      }

      this.checkedEchantillonMoyen = false
      this.checked1RapportEch = false
      return true
    }
  },
  watch: {
    numRapportSelected: function (data) {
      this.enregistrement.CENT_NRAP = this.numRapportSelected
    },
    clientSelected: function (val) {
      // When running in SAC mode and a client is selected, fetch report numbers for that client
      if (!this.isSac) return
      const vm = this
      if (!val) {
        // no client: clear list
        vm.listNumRapport = []
        return
      }
      api.getNummRapportClientByClient(val)
        .done((data) => {
          vm.listNumRapport = data.data || []
          // En mode édition, ne pas auto-incrémenter le numéro de rapport
          if (vm.modeEdition !== 'edit') {
            // choose a default next number
            setTimeout(() => {
              let max = 0
              if (vm.listNumRapport && vm.listNumRapport.length) max = Math.max(0, ...vm.listNumRapport)
              vm.numRapportSelected = max + 1
            }, 0)
          }
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    familyDataPreSelected: function (data) {
      if (this._isInitializingEdit) return
      this.enregistrement.CENT_FAM = ''
      if (data) {
        this.enregistrement.CENT_FAM = data.CFAM_FAM
        if (this.isSac && data.CFAM_FAM) {
          let userlogin = this.$root.user.login
          // Vider les analyses avant l'appel
          this.seriesAnalyses = []
          this.getSacSeriesAnalyses(userlogin, data.CFAM_FAM)
          api.getProductsGenerikByClientAndFam(userlogin, data.CFAM_FAM)
            .done((result) => {
              this.libelleEchantillon = []
              this.analysePreSelected = ''
              let pData = result.productsGenerik
              pData.forEach(element => {
                let dObject = {
                  CWL_FAM: element.CWL_FAM,
                  CWL_PDT: element.CWL_PDT,
                  fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
                  CWL_NUM: element.CWL_NUM,
                  CWL_LIB: element.CWL_LIB.trim(),
                  ID_ANALYSES: element.ID_ANALYSES,
                  nbrEchantillon: ''
                }
                this.libelleEchantillon.push(dObject)
              })
            })
            .fail(function (xhr) {
              window.fail(xhr, true)
            })
        }
        if (this.$refs.commentaireLabo) {
          this.$refs.commentaireLabo.fetchFields(data.CFAM_FAM)
        }
        if (this.$refs.commentaireClient) {
          this.$refs.commentaireClient.fetchFields(data.CFAM_FAM)
        }
      }
    },
    productDataSelected: function (data) {
      this.enregistrement.CENT_PRD = ''
      if (data) {
        this.enregistrement.CENT_PRD = data.CPRD_PRD
        this.enregistrement.CPRD_CPRD = data.CPRD_CPRD
      }
    },
    analysePreSelected: function (element) {
      this.autoCompleteForm()
    },
    productPreSelected: function (params) {
      this.preSelectAnalyse()
    },
    typeAnalysePreSelected: function (params) {
      this.checksChamp = this.checksChamp.filter((champ) => {
        return ['CENT_DATDLC', 'CENT_NBJ'].includes(champ) === false
      })

      this.validator['CENT_NBJ'] = null
      this.validator['CENT_DATDLC'] = null
      this.validator['CENT_DATFAB'] = null
      if (this.typeAnalysePreSelected.value === 2) {
        this.checksChamp.push('CENT_DATDLC')
      } else if (this.typeAnalysePreSelected.value === 3) {
        this.checksChamp.push('CENT_NBJ')
      } else {
        this.enregistrement.CENT_NBJ = 0
      }
      this.enregistrement.CENT_TYP = this.typeAnalysePreSelected.value
    },
    nbRequestRecord: function () {
      const vm = this

      if (vm.close) {
        vm.closeForm()
      }

      if (vm.nbRequestRecord > 0) {
        vm.loading = true
      } else {
        vm.loading = false
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.wizard-header {
  display: none;
}

.input-error {
  border: 1px solid red;
}
</style>




// WEBPACK FOOTER //
// src/components/DetailEchantillonComponent.vue